import { Moment } from "moment";
import { mutatorAction } from "satcheljs";
import { OpenShiftStore } from "../";

export default mutatorAction('SET_OPEN_SHIFTS_CACHE_START_TIME_IN_STORE', function setOpenShiftsCacheStartTimeInStore(cacheStartTime: Moment) {
    OpenShiftStore().cacheStartTime = cacheStartTime;
});
